import React from 'react'

const Monitoring = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.9 55.1">
      <g fill="currentColor">
        <path d="M14.2 30.3h20.7c.3 0 .6-.2.8-.5l3.9-6.8-.6 19.2c0 .4.2.8.7.9.1 0 .2.1.2.1.3 0 .6-.2.8-.5l15-26.4v13.1c0 .5.4.9.9.9h20.3c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H57.4V12.7c0-.4-.3-.8-.7-.8-.4-.1-.8.1-1 .4L40.8 38.6l.6-19.2c0-.4-.2-.8-.7-.9-.4-.1-.8.1-1 .4l-5.4 9.6H14.2c-.5 0-.9.4-.9.9s.4.9.9.9z"/>
        <path d="M90.1 0H.9C.4 0 0 .4 0 .9v53.3c0 .5.4.9.9.9H90c.5 0 .9-.4.9-.9V.9c.1-.5-.4-.9-.8-.9zm-1 53.2H1.8V1.8h87.3v51.4z"/>
      </g>
    </svg>
  )
}

export default Monitoring